import { render, staticRenderFns } from "./declareBaseInfo.vue?vue&type=template&id=be35e550&scoped=true&"
import script from "./declareBaseInfo.vue?vue&type=script&lang=js&"
export * from "./declareBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./declareBaseInfo.vue?vue&type=style&index=0&id=be35e550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be35e550",
  null
  
)

export default component.exports